import {
	MFA_SESSIONS,
	MOBILE_SDK_TESTS,
	WEB_SDK_TESTS,
	WFA_SESSIONS
} from 'src/common/providers/reactQueryProvider/QueryKeys';

import { DeleteProduct } from '../services/api/DeleteRunService';

export type DeleteEntityName = 'session' | 'test';

export const QUERY_KEY_BY_PRODUCT: Record<DeleteProduct, string> = {
	mfa: MFA_SESSIONS,
	msdk: MOBILE_SDK_TESTS,
	wfa: WFA_SESSIONS,
	wsdk: WEB_SDK_TESTS
};

export const ENTITY_BY_PRODUCT: Record<DeleteProduct, DeleteEntityName> = {
	mfa: 'session',
	msdk: 'test',
	wfa: 'session',
	wsdk: 'test'
};
